import React from "react";
import { cn } from "../../lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "rounded-lg bg-[linear-gradient(100deg,var(--muted)_40%,color-mix(in_oklch,var(--muted)_70%,var(--card))_50%,var(--muted)_60%)] bg-[length:200%_100%] [animation:shimmer_1.6s_var(--ease-standard)_infinite]",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
